<template>
	<div class="fondoModal">
		<div>
			<div style="max-width:500px;">
				<div class="card text-left">
					<div class="card-header bg-info text-white">
						<span class="fa fa-hourglass-start mr-2"></span>
						Programador
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body bg-light">
						<p>
							<span class="fa fa-info-circle mr-2"></span>
							Este es el programador de descargas del copión. Puedes seleccionar un intérvalo de tiempo y automáticamente
							se generará un fichero de audio con la grabación.
						</p>
						<p>
							También puedes programar el momento en el que se debe generar ese fichero (por ejemplo porque quieras que automáticamente se genere
							una copia de un programa que todavía no se ha emitido)
						</p>
						<p>
							A su vez también puedes crear tareas periódicas para que se ejecuten en los días que necesites. Sin embargo por motivos de seguridad
							y estabilidad del servidor, <b>solo será posible crear como máximo 5 tareas periódicas por usuario</b>.
						</p>
					</div>
					<div class="card-body bg-light">
						<h4>
							<b>
								<span class="fa fa-gear mr-2"></span>
								Emisora
							</b>
						</h4>
						<div class="mt-3">
							<select class="form-control" v-model="form.EmisoraID">
								<option :value="emisora.EmisoraID" v-for="emisora in listadoEmisoras" :key="emisora.EmisoraID">{{ emisora.Nombre }}</option>
							</select>
						</div>
						<div v-if="form.EmisoraID">
							<h4 class="mt-3">
								<b>
									<span class="fa fa-gear mr-2"></span>
									Tipo de descarga
								</b>
							</h4>
							<div class="mt-3">
								<button class="btn" :class="(!form.diferida && !form.periodica) ? 'btn-primary' : ''" @click="setAhora()">
									<span class="fa fa-download mr-2"></span>
									Instantánea
								</button>
								<button class="btn" :class="(form.diferida) ? 'btn-primary' : ''" @click="setDiferida()" >
									<span class="fa fa-clock-o mr-2"></span>
									Diferida
								</button>
								<button class="btn" :class="(form.periodica) ? 'btn-primary' : ''" @click="setProgramado()">
									<span class="fa fa-calendar mr-2"></span>
									Periodica
								</button>
							</div>
						</div>
					</div>
					<div class="card-body" v-if="form.EmisoraID">
						<h4>
							<b>
								<span class="fa fa-edit mr-2"></span>
								Detalles
							</b>
						</h4>
						<div class="input-group">
							<input type="text" class="form-control" placeholder="Escribe un título, por ejemplo: Hoy por Hoy Castellón" v-model="form.titulo">
							<div class="input-group-append">
								<button class="btn" :class="(!form.publica) ? 'btn-danger' : 'btn-default'" @click="form.publica = false">
									<span class="fa fa-lock mr-2"></span>
									Privada
								</button>
								<button class="btn" :class="(form.publica) ? 'btn-success' : 'btn-default'" @click="form.publica = true">
									<span class="fa fa-unlock mr-2"></span>
									Pública
								</button>
							</div>
						</div>
						<hr>
						<div class="row">
							<div class="col" v-if="!form.periodica && !form.diferida">
								<b>Dia</b>
								<datepicker
									:disabled-dates="{from: new Date(new Date().getTime())}"
									v-model="form.fecha"
									:monday-first="true"
									:language='$dateLang'
									:bootstrap-styling="true"
								></datepicker>
							</div>
							<div class="col">
								<b>Hora de comienzo</b>
								<input type="text" class="form-control" v-mask="'##:##'" placeholder="HH:MM" v-model="form.horaIni">
							</div>
							<div class="col">
								<b>Hora de fin</b>
								<input type="text" class="form-control" v-mask="'##:##'" placeholder="HH:MM" v-model="form.horaFin">
							</div>
						</div>
						<div class="mt-3 text-left">
							<input type="checkbox" id="chavisardiferido" v-model="form.notificaEmail">
							<label for="chavisardiferido">Avisarme por e-mail cuando esté lista</label>
						</div>
					</div>

					<!-- DESCARGA EN DIFERIDO -->
					<div class="card-body" v-if="form.diferida && form.EmisoraID">
						<h5>
							<span class="fa fa-clock-o"></span>
							<b>Descarga en diferido</b>
						</h5>
						<div class="row mt-2">
							<div class="col">
								<b>Descargar el día</b>
								<datepicker
									:disabled-dates="{to: new Date(new Date().getTime() - 86400000)}"
									v-model="form.diferida.fecha"
									:monday-first="true"
									:language='$dateLang'
									class="mt-1"
									:bootstrap-styling="true"
								></datepicker>
							</div>
						</div>
					</div>


					<!-- DESCARGA PERIODICA -->

					<div class="card-body" v-if="form.periodica && form.EmisoraID">
						<h5>
							<span class="fa fa-calendar mr-2"></span>
							<b>Descarga periódica</b>
						</h5>
						<div class="row">
							<div class="col">
								<b>Día de inicio</b>
								<datepicker
								:disabled-dates="{to: new Date(new Date().getTime() - 86400000)}"
								:monday-first="true"
								:language='$dateLang'
								:bootstrap-styling="true"
								v-model="form.periodica.fechaIni"
								></datepicker>
							</div>
							<div class="col">
								<b>Día de fin</b>
								<datepicker
								:monday-first="true"
								:language='$dateLang'
								:bootstrap-styling="true"
								v-model="form.periodica.fechaFin"
								placeholder="Opcional"
								></datepicker>
							</div>
						</div>
						<div class="mt-3">
							<b>Días de la semana</b>
							<br>
							<button
								class="btn btn-sm mr-1"
								:class="(form.periodica.dias.search((index + 1)) >= 0) ? 'btn-primary' : ''"
								v-for="(dia, index) in diasSem" :key="'dia_' + index"
								@click="toggleDiaProgramado(index + 1)"
								>{{dia}}
							</button>
						</div>
					</div>


					<div class="card-footer bg-dark text-white" v-if="form.horaIni && form.horaFin && form.EmisoraID">
						<button class="btn btn-warning" @click="programar()">
							<div v-if="!form.diferido && !form.periodica">
								<span class="fa fa-download mr-2"></span>
								Descargar
							</div>
							<div v-if="form.diferido || form.periodica">
								<span class="fa mr-2" :class="(form.diferido) ? 'fa-clock-o' : 'fa-calendar'"></span>
								Programar
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import API from '../api'

export default {
	props: ['data'],
	data () {
		return {
			form: null,
			listadoEmisoras: []
		}
	},
	computed: {
		diasSem () {
			return ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb', 'Dom']
		}
	},

	created () {
		this.getListadoEmisoras()
		this.form = _.clone(this.data)
	},
	methods: {
		getListadoEmisoras () {
			API.getEmisoras()
				.then(res => {
					this.listadoEmisoras = res.data
				})
				.catch(this.$responseError)
		},
		setAhora () {
			this.form.diferida = null
			this.form.periodica = null
			this.form.fecha = new Date()
			this.$forceUpdate()
		},
		setDiferida () {
			this.form.diferida = {
				fecha: null
			}
			this.form.fecha = null
			this.form.periodica = null
			this.$forceUpdate()
		},

		setProgramado () {
			this.form.diferida = null
			this.form.fecha = null
			this.form.periodica = {
				fechaIni: new Date(),
				fechaFin: null,
				dias: ''
			}
			this.$forceUpdate()
		},

		toggleDiaProgramado (dia) {
			if (!this.form.periodica) {
				return
			}
			if (this.form.periodica.dias.search(dia) >= 0) {
				this.form.periodica.dias = this.form.periodica.dias.replace(dia, '')
				return
			}

			this.form.periodica.dias += '' + dia
		},

		programar () {
			API.programar(_.clone(this.form))
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Programado',
						mensaje: `Se ha programado tu descarga. Te llegará un correo electrónico tan pronto como esté disponible`
					})
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/descargar-copion/vue/componentes/programador.vue